const ResponsiveContainer = ({ children, className, noMargin }) => {
  return (
    <div
      className={`xl:max-w-screen-2xl lg:max-w-screen-xl md:max-w-screen-lg max-w-full ${!noMargin ? 'mx-3 md:mx-auto' : ''} lg:pt-0 ${className}`}
    >
      {children}
    </div>
  );
};

ResponsiveContainer.defaultProps = {
  className: '',
};

export default ResponsiveContainer;
